/**
 * `/userdashboard` — auth screens + redirect to `/`. No map, `AnalysisPanel`, or layer tools here;
 * those live only under `MainDashboard` / `HomePage`.
 */
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthWrapper from '../features/user-dashboard/auth/AuthWrapper';
import { useAuth } from '../features/user-dashboard/auth/AuthContext';
import { homePathForRole } from '../features/carbon-projects/homePath';

/** After login, send users to the main map; this route is login/signup only. */
function PostLoginRedirect() {
  const navigate = useNavigate();
  const { isAuthenticated, user } = useAuth();

  useEffect(() => {
    if (isAuthenticated) {
      navigate(homePathForRole(user?.role), { replace: true });
    }
  }, [isAuthenticated, navigate, user?.role]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="text-center">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-emerald-500 mx-auto" />
        <p className="mt-3 text-sm text-gray-600">Redirecting…</p>
      </div>
    </div>
  );
}

export default function UserDashboard() {
  return (
    <AuthWrapper>
      <PostLoginRedirect />
    </AuthWrapper>
  );
}
